var map = {
	"./add-plus.png": "974b",
	"./card-bg.png": "f093",
	"./messages1.png": "1a52",
	"./messages2.png": "e01d",
	"./messages3.png": "eed5",
	"./setting.png": "e82a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "170b";